/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import apiService from '../../axios/apiService';
import PropTypes from 'prop-types';
import UserForm from './UserForm';

const AddUser = forwardRef(function AddUser({ onSuccess, onError }, ref) {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      reset: formRef?.current?.reset, // eslint-disable-line no-unused-labels
    }),
    []
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await apiService.inviteUser({
        firstName: data.firstName,
        lastName: data.lastName,
        nameTitle: data.nameTitle,
        email: data.email,
        modules: data.modules,
      });
      setLoading(false);
      onSuccess?.(response);
    } catch (error) {
      setLoading(false);
      onError?.(error);
    }
  };

  return (
    <UserForm formValues={{}} onSubmit={onSubmit} loading={loading} ref={formRef} />
  );
});

AddUser.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default AddUser;
